<template>
  <div>
    <slot
      name="item"
      v-bind="{
        valid,
        invalid: !valid,
        errors,
        touched
      }"
    />
  </div>
</template>

<script>
export default {
  name: "InputValidate",
  inject: {
    subscribe: { default: () => {} }
  },
  props: {
    name: String,
    rules: {
      // [{name: 'minLength', valid: val => val.length > 10}]
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    oneErrorAtTime: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    input: null,
    events: ["change", "blur"],
    touched: false,
    valid: true,
    errors: {},
    callbacks: [],
    unsubscribe: null
  }),
  methods: {
    onChange(callback) {
      this.callbacks.push(callback);
    },
    changed() {
      this.touched = true;
      this.check();

      this.callbacks.forEach(callbackFn => callbackFn(this));
    },
    check() {
      this.valid = this.isValid();
      this.errors = this.getErrors(this.getValue());
    },
    isValid() {
      return Object.values(this.getErrors(this.getValue())).length == 0;
    },
    getValue() {
      if (this.input.length == 0) {
        return null;
      }

      if (this.input[0].type == "checkbox") {
        return this.input[0].checked;
      }

      if (this.input[0].type == "radio") {
        const checked = this.input.find(input => input.checked);
        return checked ? checked.value : "";
      }

      return this.input[0].value;
    },
    getErrors(val) {
      let rules = [...this.rules];

      if (!this.required && this.getValue() == "") {
        return {};
      }

      if (this.required) {
        rules.unshift({ name: "required", valid: val => val != "" });
      }

      const errors = rules
        .filter(validator => !validator.valid(val))
        .map(validator => [validator.name, true]);

      return errors
        .splice(0, this.oneErrorAtTime ? 1 : errors.length)
        .reduce((pv, cv) => ({ ...pv, [cv[0]]: cv[1] }), {});
    }
  },
  mounted() {
    this.input = Array.from(this.$el.querySelectorAll(`[name="${this.name}"]`));
    this.subscribe && (this.unsubscribe = this.subscribe(this));

    if (this.input.length > 0) {
      this.events.forEach(event => {
        this.input.forEach(input => {
          input.addEventListener(event, this.changed);
        });
      });
    }
  },
  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  }
};
</script>
